import { TrashAltIcon } from "assets/icons";
import React from "react";
import { Controller, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Select } from "ui";

import {
  DriverDeliveryZoneSelectorAtomProps,
  DriverDeliveryZonesAtomProps
} from "../DriverDetailsForm.types";

import styles from "../DriverDetailsForm.module.scss";

const DeliveryZonesFields = ({
  control,
  deliveryZones,
  onRemoveDeliveryZone,
  deliveryZonesOptions,
  isDeliveryZonesLoading
}: DriverDeliveryZonesAtomProps) => {
  const onDelete = (index: number) => {
    onRemoveDeliveryZone(index);
  };
  const deliveryZonesValues = useWatch({
    control,
    name: "deliveryZones"
  });

  return (
    <div className={styles.driverForm__deliveryZones}>
      {deliveryZones.map((deliveryZone, index) => (
        <Controller
          key={`deliveryZone-${deliveryZone.id}-${index}`}
          control={control}
          name={`deliveryZones.${index}`}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <DeliveryZoneSelector
              value={value}
              onChange={onChange}
              error={error}
              isLoading={isDeliveryZonesLoading}
              deliveryZonesOptions={deliveryZonesOptions}
              index={index}
              onDelete={onDelete}
              deliveryZones={deliveryZonesValues}
            />
          )}
        />
      ))}
    </div>
  );
};

const DeliveryZoneSelector = ({
  index,
  value,
  onChange,
  onDelete,
  error,
  isLoading,
  deliveryZonesOptions,
  deliveryZones
}: DriverDeliveryZoneSelectorAtomProps) => {
  const { t } = useTranslation();

  const handledOnChange = (newValue: string | string[]) => {
    if (Array.isArray(newValue))
      onChange({ id: newValue[0], value: newValue[0] });
    else onChange({ id: newValue, value: newValue });
  };
  const filteredDeliveryZonesOptions = deliveryZonesOptions
    ?.filter(
      (zoneOption) =>
        !deliveryZones.some(
          (zone) => zone.value === zoneOption.id && zone.value !== value.value
        )
    )
    .map((zone) => ({
      label: `${zone.neighborhood}, ${zone.city}, ${zone.country}`,
      value: zone.id
    }));

  return (
    <div className={styles.driverForm__deliveryZone}>
      <div className={styles.driverForm__deliveryZone_input}>
        <Select
          isOptionsLoading={isLoading}
          value={value.value || null}
          placeholder={t("Choose value")}
          onChange={handledOnChange}
          multiple={false}
          options={filteredDeliveryZonesOptions ?? []}
          errorMessage={error?.message}
          withFilterInput={true}
        />
      </div>
      <div
        className={styles.driverForm__deliveryZone_deleteButton}
        onClick={(e) => {
          e.preventDefault();
          onDelete(index);
        }}
        data-testid={`driver--deliveryZone_deleteButton-${index}`}
      >
        <TrashAltIcon fill="#A8A8BB" width={24} height={24} />
      </div>
    </div>
  );
};

export default DeliveryZonesFields;
